import { css } from '@emotion/css';

const stySkeleton = ({ height, width, top, bottom }) => css`
  ${height ? { height } : ''}
  ${width ? { width } : ''}
  ${top ? { marginTop: top } : ''}
  ${bottom ? { marginBottom: bottom } : ''}
  color: #fff;
`;

export default stySkeleton;
